import React, { useEffect, useState } from "react";
import moment from "moment";
import SearchImg from "../../../assets/provider/images/search1.svg";
import { api } from "../../../utlis/provider/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import { routes } from "../../../utlis/provider/routes.utlis";
import { LIMIT, totalPageCalculator } from "../../../utlis/common.utlis";
import DatePicker from "react-datepicker";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

const Rating = () => {
  const [loading, setLoading] = useState(false);
  const [listing, setListing] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [toDate, setToDate] = useState(null);

  const getRatingList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all review listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setListing(response.data.data.reviews);
      setTotal(response.data.data.total);
    } else setListing([]);
    setLoading(false);
  };

  const handleFilter = (e, toDate = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    if (toDate != null && toDate != undefined && toDate != "")
      toDate = moment(toDate).format("MM/DD/yyyy");
    else toDate = "";
    getRatingList(
      api.reviewList +
        `?page=${pageNum}&limit=${LIMIT}&search=${name}&date=${toDate}`
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getRatingList(api.reviewList + `?page=${pageNum}&limit=${LIMIT}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container" style={{ minHeight: "400px" }}>
        <div className="carenetwork-section">
          <div className="care-title-header">
            <h2 className="heading-title">Rating & Review</h2>
            <div className="search-filter wd50">
              <div className="row g-2">
                <div className="col-md-5">
                  {/* <div className="form-group">
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={toDate}
                      onChange={(date, e) => {
                        setToDate(date);
                        handleFilter(e, date);
                      }}
                      className="form-control"
                      style={{ padding: "15px 40px" }}
                      isClearable
                      autoComplete="off"
                      name="date"
                      placeholderText="To Date"
                    />
                  </div> */}
                </div>

                <div className="col-md-7">
                  <div className="form-group">
                    <div className="search-form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carenetwork-content">
            <div class="care-comment-list">
              {listing?.length !== 0 ? (
                listing?.map((ele, indx) => {
                  return (
                    <div key={indx} class="care-comment-item">
                      <div class="care-comment-profile">
                        {ele?.image !== null &&
                        ele?.image !== "" &&
                        ele?.image !== undefined ? (
                          <img src={ele?.image} alt="" />
                        ) : (
                          <img src={NoImage} alt="" />
                        )}
                      </div>
                      <div class="care-comment-content">
                        <div class="care-comment-head">
                          <div class="">
                            <h2>{ele?.reviewGivenBy ?? "NA"}</h2>
                            <div class="care-comment-rating">
                              <i class="fa fa-star"></i> {ele?.rating ?? 0}
                            </div>
                          </div>
                          <div class="care-date">
                            <i class="fa fa-calendar"></i> {moment(ele?.created_date).format('MM-DD-yyyy hh:mm A')}
                          </div>
                        </div>
                        <div class="care-comment-descr">
                          {ele?.review ?? "NA"}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5% 0",
                  }}
                >
                  <img width={300} src={NoData} alt="" />
                </div>
              )}
            </div>

            <div className="d-flex align-items-center justify-content-center my-3">
              {listing.length !== 0 ? (
                <div className="care-table-pagination">
                  <ul className="care-pagination">
                    {pageNum !== 1 && (
                      <li
                        className="disabled"
                        id="example_previous"
                        onClick={() => setPageNum(pageNum - 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="0"
                          tabIndex="0"
                          className="page-link"
                        >
                          Previous
                        </Link>
                      </li>
                    )}

                    {totalPageCalculator(total, LIMIT).length === 1
                      ? null
                      : totalPageCalculator(total, LIMIT).map(
                          (pageNo, indx) => {
                            return (
                              <li
                                className={pageNo === pageNum ? "active" : ""}
                                key={indx}
                                onClick={() => setPageNum(pageNo)}
                              >
                                <Link to="" className="page-link">
                                  {pageNo}
                                </Link>
                              </li>
                            );
                          }
                        )}

                    {pageNum !== Math.ceil(total / LIMIT) && (
                      <li
                        className="next"
                        id="example_next"
                        onClick={() => setPageNum(pageNum + 1)}
                      >
                        <Link
                          to=""
                          aria-controls="example"
                          data-dt-idx="7"
                          tabIndex="0"
                          className="page-link"
                        >
                          Next
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Rating;
